$(document).ready(function () {

    var menu = $('.js-menu-outer');

    $('.js-open-menu').on('click', function () {
        menu.addClass('visible');
    });

    $('.js-close-menu').on('click', function () {
        menu.removeClass('visible');
        $('.js-child-menu').removeClass('visible');
    });

    // parent menu open child menu
    $('.js-menu-parent').on('click', function () {

        var link = $(this);
        var id = link.attr('data_nav-id');
        var child_menu = $('.js-child-menu[data_nav-id=' + id + ']');
        $('.js-child-menu').removeClass('visible');
        child_menu.addClass('visible');
    });

    // close menu when html / anywhere is clicked
    $('html').click(function() {
        menu.removeClass('visible');
        $('.js-child-menu').removeClass('visible');
    })

    // prevent above "close" menu code from running
    $('.js-open-menu').click(function(event) {
        event.stopPropagation();
    });
    $('.js-menu-item').click(function(event) {
        event.stopPropagation();
    });
    $('.js-menu').click(function(event) {
        event.stopPropagation();
    });
    $('.js-menu-parent').click(function(event) {
        event.stopPropagation();
    });


});